import script from "./MaisonetteSiteNav.vue?vue&type=script&setup=true&lang=js"
export * from "./MaisonetteSiteNav.vue?vue&type=script&setup=true&lang=js"

import "./MaisonetteSiteNav.vue?vue&type=style&index=0&id=789444e2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-789444e2"]])

export default __exports__